import PropTypes from 'prop-types'
import React from 'react'
import { useSelector } from 'react-redux'
import { useDefaultComponentTools } from '../../../../../hooks/useDefaultComponentTools'
import { selectPositionPnl } from '../../../../../store/redusers/positions/selectors'
import { selectUserCurrency } from '../../../../../store/redusers/user/selectors'
import { AppOrderItem } from '../../../../AppOrderItem'

function SidebarPnlItem({ toUpdateOpenTrade }) {
	const positionPnl = useSelector(selectPositionPnl(toUpdateOpenTrade))
	const userCurrency = useSelector(selectUserCurrency)
	const { theme } = useDefaultComponentTools()
	const directionColor = positionPnl < 0 ? theme.palette.red : theme.palette.green
	return (
		<AppOrderItem
			title={'PNL'}
			value={positionPnl}
			currency={userCurrency}
			inputSx={{'& .value': {color: directionColor} }}
		/>
	)
}

SidebarPnlItem.propTypes = {
	toUpdateOpenTrade:  PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	])
}

export default SidebarPnlItem
